import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  constructor(
    private titleService: Title,
    private translate: TranslateService
  ) {
    this.titleService.setTitle(environment.title);
    this.translate.setDefaultLang('it');
  }
}
